export default __webpack_public_path__ + "static/media/Churchil.b89d3353.png";